import { render, staticRenderFns } from "./comissionamento.vue?vue&type=template&id=53314da8&scoped=true"
import script from "./comissionamento.vue?vue&type=script&lang=js"
export * from "./comissionamento.vue?vue&type=script&lang=js"
import style0 from "./comissionamento.vue?vue&type=style&index=0&id=53314da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53314da8",
  null
  
)

export default component.exports